import { render, staticRenderFns } from "./MinhasVendas.vue?vue&type=template&id=518188fc&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./MinhasVendas.vue?vue&type=script&lang=js&"
export * from "./MinhasVendas.vue?vue&type=script&lang=js&"
import style0 from "./MinhasVendas.vue?vue&type=style&index=0&id=518188fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518188fc",
  null
  
)

export default component.exports